import React, { Component } from 'react';
import './client.css';
import InstanceButton from './instanceButton/instanceButton.js';

class Client extends Component {

  state = {
    expand: false
  }

  render() {

    const {
      client,
      instances,
      addToMonitoring,
      monitoring,
      removeFromMonitoring,
      chosenLabel
    } = this.props;

    const {expand} = this.state;

    return (
      <div className="Client">
        {
          instances.filter(this.instanceFilterFunction).length > 0 &&
          <React.Fragment>
            <button
              onContextMenu={this.handleRightClick}
              className={expand ? 'ClientButtonExpanded' : 'ClientButton'}
              onClick={this.toggleExpand}
            >
              {client}
            </button>
            {expand && instances.filter(this.instanceFilterFunction).sort(this.instanceSortFunction).map(instance => {
              return <InstanceButton
                key={instance.InstanceId}
                instance={instance}
                addToMonitoring={addToMonitoring}
                monitoring={monitoring}
                removeFromMonitoring={removeFromMonitoring}
                chosenLabel={chosenLabel}
              />;
            })}
          </React.Fragment>
        }
      </div>
    );

  }

  // Filters the functions based on what roles are chosen in the sidebar
  instanceFilterFunction = instance => {

    let allFalse = true;
    let matchingRole = false;

    Object.keys(this.props.roleFilter).forEach(role => {
      if (this.props.roleFilter[role] && instance.role === role) matchingRole = true;
      if (this.props.roleFilter[role]) allFalse = false;
    });

    if (allFalse || matchingRole) return true;
    else return false;

  }

  // A function to sort the instances by the chosen label, be that name or id.
  instanceSortFunction = (a, b) => {
    return a[this.props.chosenLabel].localeCompare(b[this.props.chosenLabel]);
  }

  toggleExpand = () => {
    this.setState({expand: !this.state.expand});
  }

  // Prevents the right clock context menu and adds all listed instances to monitoring.
  handleRightClick = e => {

    e.preventDefault();

    const {instanceFilterFunction, instanceSortFunction} = this;
    const {instances, monitoring, addToMonitoring, removeFromMonitoring} = this.props;

    const instancesToAdd = instances.filter(instanceFilterFunction).sort(instanceSortFunction);

    const newInstances = instancesToAdd.filter(instance => {
      return !monitoring.find(monitoredInstance => monitoredInstance.InstanceId === instance.InstanceId);
    });

    if (newInstances.length > 0) addToMonitoring(instancesToAdd);
    else {
      removeFromMonitoring(instancesToAdd);
    }

  }

}

export default Client;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/sidebar/client/client.js